import { Location as HLocation } from 'history';

const useQueryParams = <T extends {} = Record<string, string>>(url: Location | HLocation): T => {
  const params = url.hasOwnProperty('search') ? url.search : undefined;
  let values: Record<string, string> = {};
  if (params) {
    const urlParams = new URLSearchParams(params);
    for (const [key, value] of urlParams) {
      values = { ...values, [key]: value };
    }
  }

  return values as T;
};

export default useQueryParams;
